import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import * as Global from "../Models/constants";
import { SsrsReportJson, SsrsInputFields, HtmlKeyValue, ReportInputFields } from '../Models/common.model'

@Injectable({
    providedIn: 'root'
})

export class ssrsReportsService {
    private apiURL = window.location.href;

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        })
    }

    headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    });

    constructor(private http: HttpClient) {

    }

    getInputFields(): Observable<ReportInputFields> {
        Global.AddLogs("SSRS Reports getInputFields service method and APi Url:" + this.apiURL);
        return this.http.get<ReportInputFields>(this.apiURL + 'GetInputFieldsJson/')
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getSsrsReport(SsrsReport: SsrsReportJson): Observable<HtmlKeyValue[]> {
        Global.AddLogs("getSSRS Reports getSsrsReport service method and parameter:" + SsrsReport);
        return this.http.post<HtmlKeyValue[]>(this.apiURL + 'GetHtmlResultJson/', JSON.stringify(SsrsReport), this.httpOptions)
            .pipe(

                retry(1),
                catchError(this.handleError)
            )
    }

    downloadSsrsReport(SsrsReport: SsrsReportJson): Observable<Blob> {
        Global.AddLogs("downloadSsrsReport downloadSsrsReport service method and parameter:" + SsrsReport);
        return this.http.post<Blob>(this.apiURL + 'DoFileDownload/', JSON.stringify(SsrsReport), { headers: this.headers, responseType: 'blob' as 'json' })
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}